<template>
  <div>
    <section-header heading="2" ja="「プリクラON」を利用するには？"/>
    <div class="textArea">
      <p>「プリクラON」を初めて利用する場合は、「無料会員登録」をしてログインする必要があります。</p>
      <p>登録したアカウントは「アプリ」「Web」どちらでも使うことができます。</p>
    </div>

    <section-header heading="2" ja="メールアドレスで会員登録をしたけどログインができない"/>
    <div class="textArea">
      <p>既に会員登録済みでログインできない場合は、入力したメールアドレスとパスワードを再度ご確認ください。</p>
      <p>パスワードが分からなくなってしまった場合は、ログイン画面の「パスワードが分からない」からお進みいただき、必要事項をご入力ください。</p>
      <p>それでもログインできない場合は、メニューの「お問い合わせ」からご連絡ください。</p>
    </div>

    <section-header heading="2" ja="会員登録の方法について"/>
    <div class="textArea">
      <p>
        会員登録には「メールアドレス」「LINEアカウント」<br>
        「X(旧Twitter)アカウント」「Apple ID」のいずれかが必要です。<br>
        ※Apple IDでの会員登録、ログインはアプリ版のみご利用いただけます。<br>
       また、以下に該当するメールアドレスはご利用できません。
      </p>
      <ol>
        <li>半角英数字と「-」「_」「.」「+」「?」「/」以外の記号が含まれている</li>
        <li>記号を2文字以上連続使用している</li>
        <li>記号を最初と最後(@の直前)に使っている</li>
        <li>@の前(左部分)部分で64文字以上になっている</li>
        <li>メールアドレス全体で256文字以上になっている</li>
        <li>@の前(左部分)が「"」で囲まれている</li>
      </ol>
    </div>

    <section-header heading="2" ja="会員登録した情報を確認したい"/>
    <div class="textArea">
      <p>「プリクラON」にログインした状態で、プロフィール設定の画面で確認できます。</p>
      <p>誕生月は一度登録した場合、変更できませんのでご注意ください。</p>
    </div>

    <section-header heading="2" ja="登録しているメールアドレス、連携しているLINEアカウントやX(旧Twitter)アカウントを変更したいときは？"/>
    <div class="textArea">
      <p>「プリクラON」にログインした状態で、プロフィール設定の画面で変更することができます。</p>
      <p>※LINE/X(旧Twitter)の変更をしたい場合、一度解除する必要があります。</p>
      <p>そのため、メールアドレスの登録、もしくは他のSNSアカウントを連携して別のログインアカウントを登録している場合のみ解除することができるのでのでご注意ください。</p>
    </div>

    <section-header heading="2" ja="退会したい"/>
    <div class="textArea">
      <p>退会(会員情報の削除)は、ご自身でお手続きいただくことができます。</p>

      <p>■退会(会員削除)の方法</p>
      <ul>
        <li>「プリクラON」に削除したいアカウントでログインをします。</li>
        <li>
          <a
            class="textLink"
            href="unity:command?AccountRemove">
            「会員削除の確認」
          </a>
          画面に進んでください。
        </li>
        <li>「会員削除に進む」を選択してください。</li>
        <li>次の画面で「削除する」を選択してください。</li>
        <li>「会員削除完了」と表示されたら、お手続きは完了です。</li>
      </ul>
      <p>■注意事項</p>
      <ol>
        <li>会員削除が完了すると、そのアカウントへのログインはできなくなります。</li>
        <li>「プリクラON」のアルバムに保存されている全ての画像データが削除されます。</li>
        <li>お客様がご自分の端末(スマホ)のフォルダに保存された画像は、そのまま残ります。</li>
      </ol>
    </div>
    <sub-btn @click="onAboutWeb()">プリクラONについてに戻る</sub-btn>
  </div>
</template>

<script>
import SectionHeader from "../components/SectionHeader"
import SubBtn from '@/components/SubBtn.vue'

export default {
  name: "AboutWeb01",
  components: {
    SectionHeader,
    SubBtn
  },
  methods: {
    onAboutWeb() {
      this.$router.push("/AppaboutWeb")
    }
  }
}
</script>

<style lang="scss" scoped>
.textArea {
  margin: 30px 30px 0;
  font-size: 12px;
  color: #373737;
  p {
    margin-top: 1em;
  }
  ol{
    margin-top: 1em;
    list-style-position: inside;
  }
  ul {
    padding-left: 0;
    li {
      list-style-type: none;
      display: block;
    }
  }
}
.textLink { color: #DA2240; }
</style>
